import * as React from 'react';
import { RaRecord } from 'react-admin';

export const TaxRatesTitle = ({ record }: { record?: RaRecord }) => {
    return <span>Tax rates {record ? `"${record.name}"` : ''}</span>;
}